import { AppSetting } from 'dependencies/appsettings';
import { routeName } from 'app/routes/route-constants';

const getAppUrl = () => {  
    const appUrl = AppSetting.ApplicationUrl;
    const endsWithSlash = appUrl.charAt(appUrl.length -1) === '/';
    
    return (endsWithSlash ? appUrl : appUrl + '/');
};

export const generateCopyLinkSearch = (favouriteId: number): string => {

  return getAppUrl() + routeName.Favourite + '/' + favouriteId;
};

export const generateCopyLinkCompanyReport = (favouriteId: number): string => {

  return getAppUrl() + routeName.CompanyReport + '/' + routeName.Favourite + '/' + favouriteId;
};
